module.exports = __webpack_public_path__ + "static/media/stijn-bessem-logo-de.009f1bc3.svg";